var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#607D8A",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8A",
    d: "M76 49.333h-2.667V44c0-7.36-5.973-13.334-13.333-13.334S46.666 36.64 46.666 44v5.333H44c-2.934 0-5.334 2.4-5.334 5.334v26.666c0 2.933 2.4 5.334 5.334 5.334h32c2.933 0 5.333-2.4 5.333-5.334V54.667c0-2.934-2.4-5.334-5.333-5.334zm-16 24c-2.934 0-5.334-2.4-5.334-5.333 0-2.933 2.4-5.334 5.334-5.334 2.933 0 5.333 2.4 5.333 5.334 0 2.933-2.4 5.333-5.333 5.333zm8.266-24H51.733V44c0-4.56 3.707-8.267 8.267-8.267S68.266 39.44 68.266 44v5.333z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.33eeb66c569db165485373a52c0f6764.svg";
export { ForwardRef as ReactComponent };